import './App.css';
import React, { Suspense, lazy, useEffect, useState } from 'react';
import { createBrowserRouter, Navigate, Outlet, RouterProvider, useLocation } from 'react-router-dom';
import Loading from "./components/Loading/Loading";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Login from "./pages/Login/Login";
import Dashboard from './pages/Dashboard/Dashboard';
import { SidebarContextProvider } from "./context/SidebarContext";
import { ThemeProvider } from "./context/ThemeContext";
// import loadAssets from './utils/loadAssets';
import Users from './pages/Users/Users';
import Drivers from './pages/Drivers/Drivers';
import Offer from './pages/Offer/Offer';
import Rating from './pages/Rating/Rating';
import Review from './pages/Review/Review';
import UpdateDriver from './pages/Drivers/UpdateDriver/UpdateDriver';
import UserSettings from './pages/Settings/UserSettings/UserSettings';
import DriverSettings from './pages/Settings/DriverSettings/DriverSettings';
import SubAdmin from './pages/SubAdmin/SubAdmin';
import SubAdminUpdatePermissions from './pages/SubAdmin/SubAdminUpdatePermissions/SubAdminUpdatePermissions';
import SubAdminUpdate from './pages/SubAdmin/SubAdminUpdate/SubAdminUpdate';
import SubAdminAdd from './pages/SubAdmin/SubAdminAdd/SubAdminAdd';
import getSubAdmin from './utils/getSubAdmin';
import SubAdminNoAccess from './components/SubAdminNoAccess/SubAdminNoAccess';
import Queries from './pages/Queries/Queries';
import Bookings from './pages/Bookings/Bookings';
import CityList from './pages/City/CityList'
import City from './pages/City/City'
import DriverPayouts from './pages/Payouts/DriverPayouts';
import CancellationPolicies from './pages/Bookings/CancellationPolicies'
import Notifications from './pages/Notifications/Notifications'
import Fare from './pages/Fare/Fare';
import { jwtDecode } from "jwt-decode";
import Referrals from './pages/Referrals/Referrals';
import Template from './pages/Notifications/Template';
import PromoCodes from './pages/PromoCodes/PromoCodes'
import NightCharge from './pages/NightCharges/NightCharge';
import Pincodes from './pages/Pincodes/Pincodes';
import FAQ from './pages/Support/FAQ';
import AdminWallet from './pages/AdminWallet/AdminWallet';
import DriverWallet from './pages/Drivers/DriverWallet';
// import Support from './pages/Support/Support';
function App() {
	// const [assetsReady, setAssetsReady] = useState(false);
	// useEffect(() => {
	// loadAssets(true)
	// setAssetsReady(true);
	// }, []);





	const [adminPermissions, setAdminPermissions] = useState(null);
	const currentAdmin = localStorage.getItem('adminToken');
	const role = localStorage.getItem("adminRole");
	const uid = localStorage.getItem("adminUserId");

	useEffect(() => {
		if (role === "sub-admin") {
			getSubAdmin(uid).then((permissions) => {
				setAdminPermissions(permissions);
			});
		}
	}, []);

	useEffect(() => {
		const token = localStorage.getItem("adminToken");

		if (token) {
			try {
				const decoded = jwtDecode(token);
				const currentTime = Date.now() / 1000;

				if (decoded.exp < currentTime) {
					localStorage.clear();
					window.location.href = "/login";
				}
			} catch (err) {
				localStorage.clear();
				window.location.href = "/login";
			}
		}
	}, []);
	// Admin layout
	const LayoutAdmin = () => {
		const location = useLocation();
		useEffect(() => {
			window.scrollTo(0, 0);
		}, [location.pathname]);

		if (role === "sub-admin" && adminPermissions === null) {
			// Permissions still loading
			return <Loading />;
		}

		return (
			<>
				{
					(role === "admin") ||
						(role === "sub-admin" && adminPermissions?.[getPermissionFromPath(location.pathname)])
						?
						<>
							<Navbar />
							<Outlet />
						</>
						:
						<SubAdminNoAccess />
				}
			</>
		);
	};

	// Function to map paths to permission keys
	const permissionMap = [
		{ match: "/", permission: "dashboard_access", exact: true },
		{ match: "/driver/update", permission: "driver_edit" },
		{ match: "/driver", permission: "driver_access" },
		{ match: "/admin/sub/update/permissions", permission: "sub_admin_edit" },
		{ match: "/admin/sub/update", permission: "sub_admin_edit" },
		{ match: "/admin/sub/add", permission: "sub_admin_edit" },
		{ match: "/admin/sub", permission: "sub_admin_access" },
		{ match: "/user", permission: "user_access" },
		{ match: "/rating", permission: "ratings_access" },
		{ match: "/review", permission: "reviews_access" },
		{ match: "/offer", permission: "offers_access" },
		{ match: "/queries", permission: "queries_access" },
		{ match: "/faq", permission: "manage_FAQs" },
		{ match: "/support", permission: "manage_support" },
		{ match: "/settings/user", permission: "settings_user_management" },
		{ match: "/settings/driver", permission: "settings_driver_management" },
		{ match: "/bookings", permission: "bookings_access" },
		{ match: "/city", permission: "city_access" },
		{ match: "/fare/:city", permission: "fare_management" },
		{ match: "/payouts", permission: "payouts_access" },
		{ match: "/admin-wallet", permission: "payouts_access" },
		{ match: "/policy/cancellation", permission: "cancellation_policy_access" },
		{ match: "/notification", permission: "notification_access" },
	];

	const getPermissionFromPath = (path) => {
		for (const route of permissionMap) {
			if (route.exact && path === route.match) {
				console.log("Exact match found:", route.permission);
				return route.permission;
			}
			if (!route.exact && path.startsWith(route.match)) {
				console.log("Partial match found:", route.permission);
				return route.permission;
			}
		}
		return null;
	};



	// Protected route
	const ProtectedRouteAdmin = ({ children }) => {
		if (currentAdmin) {
			return children;
		}
		return <Navigate to="/login" />;
	};

	const router = createBrowserRouter([
		{
			path: '/',
			element: (
				<ProtectedRouteAdmin>
					<LayoutAdmin />
				</ProtectedRouteAdmin>
			),
			children: [
				{ path: '/', element: <Dashboard />, },
				{ path: '/user', element: <Users /> },
				{ path: '/driver', element: <Drivers /> },
				{ path: '/driver/update/:uid', element: <UpdateDriver /> },
				{ path: '/driver/wallet/:uid', element: <DriverWallet /> },
				{ path: '/rating', element: <Rating /> },
				{ path: '/promo-codes', element: <PromoCodes /> },
				{ path: '/review', element: <Review /> },
				{ path: '/offer', element: <Offer /> },
				{ path: '/queries', element: <Queries /> },
				{ path: '/faq', element: <FAQ /> },
				// { path: '/support', element: <Support /> },
				{ path: '/settings/user', element: <UserSettings /> },
				{ path: '/settings/driver', element: <DriverSettings /> },
				{ path: '/admin/sub', element: <SubAdmin /> },
				{ path: '/admin/sub/update/permissions/:uid', element: <SubAdminUpdatePermissions /> },
				{ path: '/admin/sub/update/:uid', element: <SubAdminUpdate /> },
				{ path: '/admin/sub/add', element: <SubAdminAdd /> },
				{ path: '/bookings', element: <Bookings view="upcoming" /> },
				{ path: '/bookings/ongoing', element: <Bookings view="ongoing" /> },
				{ path: '/bookings/completed', element: <Bookings view="completed" /> },
				{ path: '/bookings/cancelled', element: <Bookings view="cancelled" /> },
				{ path: '/city/list', element: <CityList /> },
				{ path: '/city/:uid', element: <City /> },
				{ path: '/fare/:city', element: <Fare /> },
				{ path: '/night-charges/:city', element: <NightCharge /> },
				{ path: '/payouts', element: <DriverPayouts /> },
				{ path: '/admin-wallet', element: <AdminWallet /> },
				{ path: '/policy/cancellation', element: <CancellationPolicies /> },
				{ path: '/notification/list', element: <Notifications /> },
				{ path: '/notification/templates', element: <Template /> },
				{ path: '/referrals', element: <Referrals /> },
				{ path: "/settings/picodes", element : <Pincodes/>}
			],
		},
		{
			path: '/login',
			element: (
				<Suspense fallback={<Loading />}>
					<Login />
				</Suspense>
			),
		},
		{ path: '/reset-password', element: <Login /> },
	]);

	// if (!assetsReady) {
	// 	return <Loading />;
	// }
	return (
		<ThemeProvider>
			<SidebarContextProvider adminPermissions={adminPermissions}>
				<RouterProvider router={router} />
			</SidebarContextProvider>
		</ThemeProvider>
	);
}

export default App;
